export default function DownloadSection() {
  return (
    <section id="download" className="relative py-14 md:py-20 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20digital%20gradient%20background%20with%20warm%20orange%20and%20deep%20amber%20tones%2C%20flowing%20geometric%20patterns%2C%20soft%20atmospheric%20light%20rays%2C%20clean%20minimal%20aesthetic%2C%20dark%20rich%20base%20with%20bright%20warm%20accents%2C%20cinematic%20mood%2C%20professional%20technology%20atmosphere&width=1920&height=800&seq=download-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 via-background-950/70 to-background-950/85"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-background-50 mb-4">
              立即下载 <span className="text-primary-400">快猫视频</span>
            </h2>
            <p className="text-sm md:text-base text-background-300 max-w-md mb-8 leading-relaxed">
              支持iOS和Android双平台，扫描二维码或在应用商店搜索"快猫视频"即可免费下载。海量精彩短视频，随时随地想看就看！
            </p>

            <div className="flex flex-col sm:flex-row items-center lg:items-start gap-3">
              <a
                href="#"
                className="w-full sm:w-auto px-7 py-3 bg-background-50 text-foreground-950 font-medium rounded-full text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-apple-fill text-lg"></i>
                iOS 版下载
              </a>
              <a
                href="#"
                className="w-full sm:w-auto px-7 py-3 bg-primary-500 text-background-50 font-medium rounded-full text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 版下载
              </a>
            </div>

            <p className="mt-4 text-xs text-background-400">
              兼容 iOS 14+ / Android 8.0+ | 版本 v6.8.0 | 大小 85MB
            </p>
          </div>

          <div className="flex-shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 bg-background-50 rounded-3xl p-3">
              <div className="w-full h-full bg-background-200 rounded-2xl flex items-center justify-center">
                <div className="text-center">
                  <i className="ri-qr-code-line text-5xl text-foreground-600"></i>
                  <p className="text-xs text-foreground-500 mt-2">扫码下载</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}